import { getAppUrl } from '@/lib/supabase'

export const getBaseUrl = () => {
  // In production, window.location.origin is authoritative for building short URLs.
  // Only fall back to build-time/server config when running locally.
  const origin = window.location.origin
  if (!origin.includes('localhost') && !origin.includes('127.0.0.1')) return origin
  return import.meta.env.VITE_BASE_URL || getAppUrl()
}

export const getShortUrl = (shortcode: string, customDomain?: string) => {
  if (customDomain) {
    return `https://${customDomain}/${shortcode}`
  }
  return `${getBaseUrl()}/${shortcode}`
}

export const getShortUrlDisplay = (shortcode: string, customDomain?: string) => {
  const url = getShortUrl(shortcode, customDomain)
  return url.replace(/^https?:\/\//, '')
}
